import React from "react";
import { Card } from 'react-bootstrap'
import { IRate, IPaymentChoice, IRealTimeAutoResult } from "../classes/Domain";
import CoveragesOverview from '../components/CoveragesOverview';
import PaymentChoice from '../components/PaymentChoice';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from "swiper";
import SwiperCore, { Pagination } from 'swiper';
import Utilities from "../classes/Utilities";
import RateErrorHandler from "./RateErrors/RateErrorHandler";
import "react-toggle/style.css"
import * as _ from 'lodash';
import Collapsible from 'react-collapsible';

interface IRateResultProps {
    rateResult: IRate,
    currentRate: IRealTimeAutoResult | null | undefined,
    index: number,
    onPaymentChoiceSelected(paymentChoice: IPaymentChoice): void,
    reRate?: () => void;
}

interface IState {
    fullPayChoice : IPaymentChoice | null | undefined,
    installmentsChoice: IPaymentChoice | null | undefined,
    isPaymentChoiceSelected: boolean,
    isCollapsibleOpen: boolean
}

class RateResult extends React.Component<IRateResultProps, IState> {
    private _swiper: SwiperClass;

	constructor(props: IRateResultProps) {
        super(props);

        var isMainPayPlanSelected = this.props.rateResult.paymentChoices.some((x, y) => x.selected && (y == 0 || y == 1));
        var isAdditionalPayPlanSelected = this.props.rateResult.paymentChoices.some((x, y) => x.selected && y > 1);

        this.state = {
            fullPayChoice: null,
            installmentsChoice: null,
            isPaymentChoiceSelected: false,
            isCollapsibleOpen: isAdditionalPayPlanSelected || !isMainPayPlanSelected
        };

        this.onPaymentChoiceSelected = this.onPaymentChoiceSelected.bind(this);
        this.renderBullet = this.renderBullet.bind(this);
        this._swiper = new SwiperClass(".swiper-container");

        SwiperCore.use([Pagination]);
    }

    getValueSafe(obj: any, property: string) {
        return obj ? obj[property] : "";
    }

    componentDidMount() {
        const fullPay = _.find(this.props.rateResult?.paymentChoices, (choice) => 0 === choice.payCount);
        const installmentsPay = _.find(this.props.rateResult?.paymentChoices, (choice) => 0 < choice.payCount);
        this.setState({ ...this.state, fullPayChoice: fullPay, installmentsChoice: installmentsPay });
    }

    onPaymentChoiceSelected(paymentChoice: IPaymentChoice) {
        this.props.onPaymentChoiceSelected(paymentChoice);
    }

    renderBullet(index: number, className: string) {
        if (0 === index && 0 < this.props.rateResult.paymentChoices.length) {
            return '<div class="' + className + '"><i class=\"fas fa-money-check-alt\"></i><span class=\"bullet-caption\">Payment Plans</span></div>';
        }

        //var vehicleRates = _.filter(this.props.rateResult.rate.vehicleRates, (vr) => !!vr.make);

        //if (1 + vehicleRates.length === index && this.props.rateResult.rate.messageMemo) {
        //    return '<div class="' + className + '"><i class=\"far fa-comment-dots\"></i><div class=\"bullet-caption\">Message</div></div>';
        //}

        if (0 < index && 0 < _.filter(this.props.currentRate?.vehicleRates, (vr) => !!vr.make).length) {
            return '<div class="' + className + '"><i class=\"fas fa-car\"></i><span class=\"bullet-caption\">Coverage Details</span></div>';
        }

        return "";
    }

	render() {
		return (
            <Card className="rtr-rate-result">
                <Card.Body>
                    {
                        //this.props.rateResult.rate.messageMemo
                        //    ?
                        //    <Alert variant={"warning"} className="m-t-20">
                        //        <p className="message-body" dangerouslySetInnerHTML={{ __html: this.props.rateResult.rate.messageMemo }}></p>
                        //    </Alert>
                        
                        //: null
                    }

                    {
                        this.props.rateResult.offerErrors
                            ? <RateErrorHandler
                                offerErrors={this.props.rateResult.offerErrors}
                                reRate={this.props.reRate} />
                            : null
                    }
                    
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={"auto"}
                        centeredSlides={true}
                        autoHeight={true}
                        pagination={{
                            type: "bullets",
                            renderBullet: this.renderBullet,
                            clickable: true
                        }}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                        runCallbacksOnInit={true}
                        onInit={(swiper) => {
                            this._swiper = swiper
                        }}>

                        {
                            this.props.rateResult.paymentChoices && 0 < this.props.rateResult.paymentChoices.length
                                ?
                                <SwiperSlide key={Utilities.uniqueId()}>
                                    <div className="payment-choices">
                                        <PaymentChoice
                                            key={Utilities.uniqueId()}
                                            paymentChoice={this.props.rateResult.paymentChoices[0]}
                                            onSelected={() => this.onPaymentChoiceSelected(this.props.rateResult.paymentChoices[0])} />
                                        <PaymentChoice
                                            key={Utilities.uniqueId()}
                                            paymentChoice={this.props.rateResult.paymentChoices[1]}
                                            onSelected={() => this.onPaymentChoiceSelected(this.props.rateResult.paymentChoices[1])} />
                                        <Collapsible
                                            trigger="View additional payment plans"
                                            open={this.state.isCollapsibleOpen}
                                            onOpen={() => { this._swiper?.updateAutoHeight(100) }}
                                            onClose={() => { this._swiper?.updateAutoHeight(100) }}>
                                            {this.props.rateResult.paymentChoices.filter((v, idx) => idx > 1).map((paymentChoice) => (
                                                <PaymentChoice
                                                    key={Utilities.uniqueId()}
                                                    paymentChoice={paymentChoice}
                                                    onSelected={() => this.onPaymentChoiceSelected(paymentChoice)} />
                                            ))}
                                        </Collapsible>
                                    </div>
                                </SwiperSlide>
                                : null
                        }

                        {
                            0 < _.filter(this.props.currentRate?.vehicleRates, (vr) => !!vr.make).length
                                ?
                                <SwiperSlide>
                                    <div className="coverages">
                                        {_.filter(this.props.currentRate?.vehicleRates, (vr) => !!vr.make).map((vehicleRate) => (
                                            <CoveragesOverview key={Utilities.uniqueId()} vehicleRate={vehicleRate} />
                                        ))}
                                    </div>
                                </SwiperSlide>
                                : null
                        }

                    </Swiper>
                </Card.Body>
            </Card>
		);
	}
}

export default RateResult;